import React from 'react';
import classnames from 'classnames';
import { atoms } from '@fiverr-private/theme';
import { I18n } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { ModalType, openFipMigrationModal } from '@fiverr-private/pro_migration';
import { mixpanel } from '@fiverr-private/obs';
import Link from '../Link';
import Nav from '../../../lib/Nav';

interface BuyerInviteYourTeamLinkProps {
    showProBadge?: boolean;
}

const BuyerInviteYourTeamLink: React.FC<BuyerInviteYourTeamLinkProps> = ({ showProBadge = true }) => {
    const { userId } = getContext();

    const handleClick = () => {
        openFipMigrationModal({
            variant: ModalType.SeamlessCollaboration,
            payload: {
                source: 'avatar_menu',
                biEnrichment: {
                    pageName: 'seamless_avatar_menu_collaboration',
                    pageElementName: 'seamless_avatar_menu_collaboration',
                },
            },
        });

        mixpanel.track('Invite member avatar menu clicked', {});
    };

    const bqData = {
        group: 'header_clicks',
        type: 'clicked_header.invite_your_team',
        user: {
            id: userId,
            navigation_mode: 'buying',
        },
    };

    return (
        <Nav.PopoverItem>
            <Link
                onClick={handleClick}
                bigQueryData={bqData}
                isPro={showProBadge}
                className={classnames(atoms({ cursor: 'pointer' }), 'nav-link')}
            >
                <I18n k="header.invite_your_team" />
            </Link>
        </Nav.PopoverItem>
    );
};

export default BuyerInviteYourTeamLink;
